import { render, staticRenderFns } from "./StockLocation.vue?vue&type=template&id=46dc9684&scoped=true"
import script from "./StockLocation.vue?vue&type=script&lang=js"
export * from "./StockLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc9684",
  null
  
)

export default component.exports